import { useLocation, Outlet } from 'react-router';
import { useMemo } from 'react';
import {
    LayoutGrid01,
    Users01,
    Settings01,
    File02,
    HelpCircle,
    Dataflow03,
    BookOpen01,
    BarChart01
} from '@untitledui/icons';
import { SidebarNavigationSimple } from '@/components/application/app-navigation/sidebar-navigation/sidebar-simple';
import type { NavItemType } from '@/components/application/app-navigation/config';
import { useTranslation } from 'react-i18next';

export const AdminLayout = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const { t } = useTranslation('navigation');

    // Rileva se siamo in una pagina di workflow (viewing o editing)
    const isWorkflowPage = useMemo(() => {
        return /^\/admin\/workflows\/[^/]+/.test(currentPath);
    }, [currentPath]);

    // Navigation items for sidebar
    const sidebarItems: NavItemType[] = [
        {
            label: t('dashboard'),
            href: '/admin/dashboard',
            icon: LayoutGrid01
        },
        {
            label: t('companies'),
            href: '/admin/companies',
            icon: Users01
        },
        {
            label: t('documents'),
            href: '/admin/documents',
            icon: File02
        },
        {
            label: t('workflows'),
            href: '/admin/workflows',
            icon: Dataflow03
        },
        {
            label: t('knowledgeBase'),
            href: '/admin/knowledge',
            icon: BookOpen01
        },
        {
            label: t('analytics'),
            href: '/admin/analytics',
            icon: BarChart01
        },
        {
            label: t('settings'),
            href: '/admin/settings',
            icon: Settings01
        }
    ];

    // Footer items for sidebar
    const footerItems: NavItemType[] = [
        {
            label: t('support'),
            href: '#',
            icon: HelpCircle
        },
    ];

    const env = import.meta.env.VITE_ENV;
    const hasEnvironmentBanner = env !== "production";

    return (
        <div className={`flex h-screen bg-secondary ${hasEnvironmentBanner ? "pt-7" : ""}`}>
            {/* Sidebar Navigation */}
            <SidebarNavigationSimple
                activeUrl={currentPath}
                items={sidebarItems}
                footerItems={footerItems}
                showAccountCard={true}
                className="hidden lg:flex"
            />

            {/* Page Content */}
            <main className="flex-1 overflow-auto bg-secondary">
                {isWorkflowPage ? (
                    <Outlet />
                ) : (
                    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                        <Outlet />
                    </div>
                )}
            </main>
        </div>
    );
};
